import { MONTH_DAY_YEAR_FORMAT } from '@/Framework/DateTime/dateFormats';
import React from 'react';
import cn from 'classnames';
import { format, isSameDay } from 'date-fns';
import { BodyCell } from '@dealroadshow/uikit/core/components/Table/DataTable';
import { IFilling } from '@/finsight/domain/vo/Filings/Filings';
import utcToZonedDate from '@/Framework/DateTime/utcToZonedDate';
import { filingTimeFormat } from '@/finsight/ui/components/filings/constants';

import filingsCellsStyles from './filingsCells.scss';
import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';
import spaces from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';

const getFormattedFilingDate = ({ row: { acceptanceDatetime } }) => {
  const {
    timezone,
    dateTime,
  } = acceptanceDatetime;
  // acceptanceDatetime is of form 'YYYY-MM-DD hh:mm:ss'.
  const time = utcToZonedDate(timezone.timeZone, new Date(dateTime));
  const isToday = isSameDay(time, utcToZonedDate(timezone.timeZone));
  // If the filing was made today, show the time instead of date.
  if (isToday) {
    return `${ format(time, filingTimeFormat) } ${ acceptanceDatetime.datetime?.timezone?.abbr || ' ET' }`;
  }
  return format(time, MONTH_DAY_YEAR_FORMAT);
};

interface IDateCellPropTypes {
  customClassName: string,
  rowIndex: number,
  filing: IFilling,
}

const DateCell = ({
  rowIndex,
  filing,
  customClassName,
}: IDateCellPropTypes) => (
  <BodyCell
    name="DateCell"
    dataTest="dateCell"
    className={ cn(alignStyles.alignRight, spaces.prl, filingsCellsStyles.noWrap, customClassName) }
    rowIndex={ rowIndex }
    rowData={ filing }
    cellCallback={ getFormattedFilingDate }
  />
);

export default DateCell;
